import { useState } from "react";
import { Terminal, ChevronUp, X } from "lucide-react";

export const DevDrawer = ({ transcript, logs = [], rawLlm }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open && (
        <button
          data-testid="dev-drawer-toggle"
          onClick={() => setOpen(true)}
          className="fixed bottom-4 right-4 z-50 flex items-center gap-2 glass rounded-full px-4 sm:px-5 py-2.5 text-xs sm:text-sm text-[#94A3B8] hover:text-[#F8FAFC] border border-white/10 hover:border-[#22C55E]/40 transition-all whitespace-nowrap"
        >
          <Terminal className="h-4 w-4 text-[#22C55E]" />
          <span>Agent Logs</span>
          <ChevronUp className="h-4 w-4" />
        </button>
      )}

      {open && (
        <div
          data-testid="dev-drawer-panel"
          className="fixed bottom-0 left-0 right-0 z-50 h-[45vh] glass border-t border-[#22C55E]/20 flex flex-col fade-up"
        >
          <div className="flex items-center justify-between px-6 py-3 border-b border-white/10">
            <div className="flex items-center gap-2 text-sm font-semibold">
              <Terminal className="h-4 w-4 text-[#22C55E]" />
              Developer Drawer — Wispr Flow & Agent Logs
            </div>
            <button data-testid="dev-drawer-close" onClick={() => setOpen(false)} className="text-[#94A3B8] hover:text-[#F8FAFC]">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="flex-1 overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-4 p-5">
            <div className="overflow-y-auto rounded-lg bg-[#0F1117]/70 border border-white/5 p-4">
              <div className="text-[11px] uppercase tracking-widest text-[#22C55E] mb-2">Raw Voice Transcript</div>
              <p className="text-sm text-[#CBD5E1] font-serif-i leading-relaxed whitespace-pre-wrap">{transcript || "—"}</p>
              {rawLlm && (
                <>
                  <div className="text-[11px] uppercase tracking-widest text-[#3B82F6] mt-4 mb-2">LLM Structured Output (truncated)</div>
                  <pre className="text-[11px] text-[#64748B] whitespace-pre-wrap break-words font-mono">{rawLlm}</pre>
                </>
              )}
            </div>

            <div className="overflow-y-auto rounded-lg bg-[#0F1117]/70 border border-white/5 p-4 font-mono text-xs">
              <div className="text-[11px] uppercase tracking-widest text-[#3B82F6] mb-2">Backend Agent Execution Log</div>
              {logs.length === 0 && <div className="text-[#64748B]">No logs yet…</div>}
              {logs.map((l, i) => (
                <div key={i} className="mb-1.5 flex gap-2" data-testid="dev-log-line">
                  <span className="text-[#475569] shrink-0">{(l.timestamp || "").slice(11, 19)}</span>
                  <span className="text-[#22C55E] shrink-0">[{l.agent}]</span>
                  <span className="text-[#CBD5E1]">{l.message}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
